module.exports = __webpack_public_path__ + "static/20230419_183805-trimmed-4ccc43a44ad9f058973edcac9c6bc254.jpg";